// easyMarkets uses 'zh-hans'/'zh-hant'; DealSize's supported locales use 'zh-CN'/'zh-TW'.
// Italian ('it') and Polish ('pl') have no DealSize equivalent yet, so they fall back to English.
const DEALSIZE_LOCALE_MAP = {
	'zh-hans': 'zh-CN',
	'zh-hant': 'zh-TW',
	'cn': 'zh',
	'ja': 'ja',
	'jp': 'ja',
};

function toDealSizeLocale(locale) {
	const normalized = (locale || 'en').toLowerCase();

	return DEALSIZE_LOCALE_MAP[normalized] || normalized;
}

export { DEALSIZE_LOCALE_MAP, toDealSizeLocale };
